import React, { useEffect } from 'react'

import { graphql } from 'gatsby'

import SEO from 'src/components/seo/index'
import Header from 'src/components/header/setting'
import Link from 'src/components/link/index'

import { SlideinWrap, SlideinItem } from 'src/components/slidein/index'

import Keyvisual from './parts/keyvisual'
import Overview from './parts/overview'
import Gallery from './parts/gallery'
import Movie from './parts/movie'
import Text from './parts/text'
import Products from './parts/products'
import Profile from './parts/profile'
import Latests from './parts/latests'

import * as styles from './index.module.scss'


export const query = graphql`
    query($id: String!) {
        article: wpArticle(id: { eq: $id }) {
            custom {
                title
                titleSize
                datetime
                lead
                visualPc { ...Image1920 }
                visualSp { ...Image750 }
                sections {
                    __typename
                    ... on WpArticle_Custom_Sections_Block {
                        align, title, content
                        products {
                            id, url, name, brand, price
                        }
                        visualCenter {
                            __typename
                            ... on WpArticle_Custom_Sections_Block_VisualCenter_Images {
                                images {
                                    imagePc { ...Image960 }
                                    imageSp { ...Image750 }
                                    caption
                                }
                            }
                            ... on WpArticle_Custom_Sections_Block_VisualCenter_Youtube {
                                youtubeVideoId, caption
                            }
                        }
                        visualSide {
                            __typename
                            ... on WpArticle_Custom_Sections_Block_VisualSide_Images {
                                images {
                                    imagePc { ...Image360 }
                                    imageSp { ...Image680 }
                                    caption
                                }
                            }
                        }
                    }
                    ... on WpArticle_Custom_Sections_Lookbook {
                        align
                        visualCenterL {
                            __typename
                            ... on WpArticle_Custom_Sections_Lookbook_VisualCenterL_Images {
                                images {
                                    imagePc { ...Image1280 }
                                    imageSp { ...Image750 }
                                    caption
                                }
                                products {
                                    id, url, name, brand, price
                                }
                            }
                        }
                        visualCenterM {
                            __typename
                            ... on WpArticle_Custom_Sections_Lookbook_VisualCenterM_Images {
                                images {
                                    imagePc { ...Image960 }
                                    imageSp { ...Image680 }
                                    caption
                                }
                                products {
                                    id, url, name, brand, price
                                }
                            }
                        }
                        visualSide {
                            __typename
                            ... on WpArticle_Custom_Sections_Lookbook_VisualSide_Images {
                                images {
                                    imagePc { ...Image680 }
                                    imageSp { ...Image680 }
                                    caption
                                }
                                products {
                                    id, url, name, brand, price
                                }
                            }
                        }
                        visualBoth {
                            __typename
                            ... on WpArticle_Custom_Sections_Lookbook_VisualBoth_Images {
                                images {
                                    imagePc { ...Image560 }
                                    imageSp { ...Image680 }
                                    caption
                                }
                                products {
                                    id, url, name, brand, price
                                }
                            }
                        }
                    }
                    ... on WpArticle_Custom_Sections_Button {
                        url
                        text
                    }
                    ... on WpArticle_Custom_Sections_Profile {
                        profiles {
                            name
                            description
                            instagramName
                            instagramUrl
                            image { ...Image160 }
                        }
                    }
                }
            }
            tags: articleTags {
                nodes { name }
            }
        }
        latests: allWpArticle(
            limit: 12
            sort: {
                fields: custom___datetime
                order: DESC
            }
            filter: {
                id: {
                    ne: $id
                }
            }
        ) {
            nodes {
                custom {
					slug, type, url, title, lead, datetime
					thumbnailPc { ...Image660 }
					thumbnailSp { ...Image660 }
                }
                tags: articleTags {
                    nodes { name }
                }
            }
        }
    }
`


const ArticleItemPage = ({ data }) => {

    // 商品アクティブ判定
    useEffect(() => {
        if (typeof window !== `undefined`) {
            new window['beams-checkItemId']()
        }
    }, [])

    return (
        <div className={styles.article}>
            <SEO title={data.article.custom.title} description={data.article.custom.lead} />
            <Header color={`white`} />

            <Keyvisual imagePC={data.article.custom.visualPc} imageSP={data.article.custom.visualSp} />

            <Overview data={data} />

            {data.article.custom.sections && data.article.custom.sections.map((section, i) => (
                <section key={i}>

                    {section.__typename.match(/Block$/) && (
                        <div className={styles.block} data-align={section.align}>
                            {section.align === 'center' && (
                                <React.Fragment>
                                    {section.visualCenter && (
                                        <div className={styles.visual}>
                                            {section.visualCenter[0].__typename.match(/Images$/) && (
                                                <Gallery images={section.visualCenter[0].images} align={section.align} />
                                            )}
                                            {section.visualCenter[0].__typename.match(/Youtube$/) && (
                                                <Movie vid={section.visualCenter[0].youtubeVideoId} caption={section.visualCenter[0].caption} />
                                            )}
                                        </div>
                                    )}
                                    <div className={styles.inner}>
                                        <Text {...section} />
                                    </div>
                                </React.Fragment>
                            )}

                            {(section.align === 'left' || section.align === 'right') && (
                                <React.Fragment>
                                    {section.visualSide && (
                                        <div className={styles.visual}>
                                            {section.visualSide[0].__typename.match(/Images$/) && (
                                                <Gallery images={section.visualSide[0].images} align={section.align} />
                                            )}
                                        </div>
                                    )}
                                    <div className={styles.half}>
                                        <Text {...section} />
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    )}

                    {section.__typename.match(/Lookbook$/) && (
                        <div className={styles.lookbook} data-align={section.align}>
                            {(section.align === 'center_l') && section.visualCenterL && (
                                <div className={styles.box}>
                                    <Gallery images={section.visualCenterL[0].images} align={section.align} />
                                    <SlideinWrap className={styles.products}>
                                        <SlideinItem>
                                            <Products products={section.visualCenterL[0].products} />
                                        </SlideinItem>
                                    </SlideinWrap>
                                </div>
                            )}
                            {(section.align === 'center_m') && section.visualCenterM && (
                                <div className={styles.box}>
                                    <Gallery images={section.visualCenterM[0].images} align={section.align} />
                                    <SlideinWrap className={styles.products}>
                                        <SlideinItem>
                                            <Products products={section.visualCenterM[0].products} />
                                        </SlideinItem>
                                    </SlideinWrap>
                                </div>
                            )}
                            {(section.align === 'left' || section.align === 'right') && section.visualSide && (
                                <div className={styles.box}>
                                    <Gallery images={section.visualSide[0].images} align={section.align} />
                                    <SlideinWrap className={styles.products}>
                                        <SlideinItem>
                                            <Products products={section.visualSide[0].products} />
                                        </SlideinItem>
                                    </SlideinWrap>
                                </div>
                            )}
                            {(section.align === 'both') && section.visualBoth && (
                                <React.Fragment>
                                    <div className={styles.box}>
                                        {section.visualBoth[0] && (
                                            <React.Fragment>
                                                <Gallery images={section.visualBoth[0].images} align={section.align} />
                                                <SlideinWrap className={styles.products}>
                                                    <SlideinItem>
                                                        <Products products={section.visualBoth[0].products} />
                                                    </SlideinItem>
                                                </SlideinWrap>
                                            </React.Fragment>
                                        )}
                                    </div>
                                    <div className={styles.box}>
                                        {section.visualBoth[1] && (
                                            <React.Fragment>
                                                <Gallery images={section.visualBoth[1].images} align={section.align} />
                                                <SlideinWrap className={styles.products}>
                                                    <SlideinItem>
                                                        <Products products={section.visualBoth[1].products} />
                                                    </SlideinItem>
                                                </SlideinWrap>
                                            </React.Fragment>
                                        )}
                                    </div>
                                </React.Fragment>
                            )}
                        </div>
                    )}

                    {section.__typename.match(/Button$/) && (
                        <SlideinWrap className={styles.button}>
                            <SlideinItem>
                                <Link to={section.url}>{section.text}</Link>
                            </SlideinItem>
                        </SlideinWrap>
                    )}

                    {section.__typename.match(/Profile$/) && (
                        <div className={styles.profile}>
                            {section.profiles && section.profiles.map((profile, i) => (
                                <Profile key={i} {...profile} />
                            ))}
                        </div>
                    )}

                </section>
            ))}

            <SlideinWrap className={styles.backToList}>
                <SlideinItem>
                    <Link to="/article/">BACK TO LIST</Link>
                </SlideinItem>
            </SlideinWrap>

            <Latests latests={data.latests} />
        </div>
    )
}

export default ArticleItemPage
